export const initFaqSectionScript = () => {
  const faqSection = document.querySelector('.faq-section');
  const faqTitles = faqSection?.querySelectorAll('.faq-titles button');
  const faqItems = faqSection?.querySelectorAll('.faq-item');
  const faqSelect = faqSection?.querySelector('.faq-select');
  const selectedFaqTitle = faqSection?.querySelector('.faq__selected-title');
  const faqButtons = faqSection?.querySelectorAll('.faq-item button');
  let activeAccordions = [];

  function toggleFaq(key) {
    // Clear active accordions before adding new ones
    activeAccordions = [];

    faqItems.forEach((item) => {
      const isActive = item.dataset.key === key;
      item.classList.toggle('hidden', !isActive);
      if (isActive) {
        activeAccordions.push(item);
      }
    });

    // Ensure only the first accordion of the active FAQ items is open
    activeAccordions.forEach((item, id) => {
      const isFirstAccordion = id === 0;
      toggleAccordion(item, isFirstAccordion);
    });
    handleUpdateFaqTitle(key);
  }

  function handleUpdateFaqTitle(titleId) {
    const matchingTitle = [...faqTitles].find(
      (title) => title.dataset.key === titleId,
    );
    if (matchingTitle) {
      selectedFaqTitle.textContent = matchingTitle.textContent;
    }

    faqTitles.forEach((title) => {
      title.classList.remove('is-active');
    });

    if (matchingTitle) {
      matchingTitle.classList.add('is-active');
    }
  }
  function toggleAccordion(accordion, condition) {
    accordion.classList.toggle('accordion-active', condition);
  }

  faqTitles.forEach((title) => {
    title.addEventListener('click', () => {
      toggleFaq(title.dataset.key);
    });
  });

  if (faqSelect) {
    faqSelect.addEventListener('change', () => {
      toggleFaq(faqSelect.value);
    });
  }

  if (faqTitles.length > 0) {
    const firstKey = faqTitles[0].dataset.key;
    toggleFaq(firstKey);
  }

  // Apply the accordion logic to each button
  faqButtons.forEach((button) => {
    const faqItem = button.closest('.faq-item');

    button.addEventListener('click', () => {
      toggleAccordion(faqItem);
    });
  });
};
